import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { CommissionsScope } from '../types';

interface WidgetScopeToggleProps {
    value: CommissionsScope;
    onChange: (next: CommissionsScope) => void;
}

// Superuser-only switch between everyone (team totals) and the user's own data.
export const WidgetScopeToggle = ({ value, onChange }: WidgetScopeToggleProps) => (
    <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_, next: CommissionsScope | null) => {
            if (next) onChange(next);
        }}
        aria-label="Widget scope"
    >
        <ToggleButton value="all">All users</ToggleButton>
        <ToggleButton value="mine">Mine</ToggleButton>
    </ToggleButtonGroup>
);

WidgetScopeToggle.displayName = 'WidgetScopeToggle';
